import { Formik, FormikProps } from 'formik';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { Stack } from 'office-ui-fabric-react';

import {
  filtersContext,
  FiltersList,
  FormValues,
  getMobileFilters,
  ParsedFilters,
} from 'api/mobile/filters';
import { VehicleInput } from './VehicleInput';
import { SubmitOnEveryChange } from 'views/pages/Cordova/components/SubmitOnEveryChange';
import { mapContext } from '../../mapContext';

export const Vehicle: React.FC = () => {
  const [filters, setFilters] = useState<FiltersList>({
    branches: [],
    depots: [],
    vehicles: [],
    routes: [],
    date: null,
  });
  const [parsedFilters, setParsedFilters] = useState<ParsedFilters>({
    vehicles: [],
    routes: [],
    depots: [],
    branches: [],
    transporttypes: [],
    gosNomer: [],
  });

  const { onSearchVehicles, filteredVehicle } = useContext(mapContext);

  const formikRef = useRef<FormikProps<FormValues>>(null);

  useEffect(() => {
    if (filteredVehicle) {
      formikRef.current?.setFieldValue('vehicle', [filteredVehicle.id]);
      formikRef.current?.setFieldValue('gosNomer', [filteredVehicle.id]);
    }
  }, [filteredVehicle]);

  useEffect(() => {
    const getFilters = async () => {
      const data = await getMobileFilters();
      if (data) {
        setFilters(data.filters);
        setParsedFilters(data.parsedFilters);
      }
    };
    getFilters();
  }, []);

  const onSubmit = (values: FormValues) => {
    const [filteredVehicle] = filters.vehicles.filter(({ id }) =>
      values.vehicle.includes(id)
    );
    /*.filter((vehicle) => {
      let result = true;
      (Object.keys(values) as (keyof FormValues)[]).forEach((key) => {
        if (!values[key].length) return;
        const filter = (vkey: keyof typeof vehicle) => {
          if (
            !(values[key] as unknown[]).find((value) => value === vehicle[vkey])
          ) {
            result = false;
          }
        };
        switch (key) {
          case 'branch':
            filter('branch');
            break;
          case 'route':
            filter('route_id');
            break;
          case 'routeType':
            filter('routeType');
            break;
          case 'vehicle':
          case 'gosNomer':
            filter('id');
            break;
        }
      });
      return result;
    });*/
    onSearchVehicles(filteredVehicle || null);
  };

  return (
    <filtersContext.Provider
      value={
        {
          parsedFilters,
          filters,
        } as any
      }
    >
      <Formik<FormValues>
        initialValues={{
          route: [],
          branch: [],
          vehicle: [],
          routeType: [],
          gosNomer: [],
        }}
        onSubmit={onSubmit}
        innerRef={formikRef as never}
      >
        <Stack tokens={{ childrenGap: 16 }}>
          <SubmitOnEveryChange />
          <VehicleInput name="branch" label="Филиал" />
          <VehicleInput name="route" label="Маршрут" />
          <VehicleInput name="routeType" label="Вид ТС" />
          <VehicleInput
            singleSelection={true}
            name="vehicle"
            label="Гаражный номер"
          />
          <VehicleInput singleSelection={true} name="gosNomer" label="ГРЗ" />
        </Stack>
      </Formik>
    </filtersContext.Provider>
  );
};
